import type { BreadcrumbItemInput, ServiceSchemaInput } from "@modes0/ui-components-seo";
import type { SubCategory } from "@/types";

export const getServiceHref = (service: SubCategory) =>
    service.link || `/${service.headCategory.categoryType}/${service.headCategory.slug}/${service.slug}`;

export const getServiceSeoInput = (service: SubCategory): ServiceSchemaInput => ({
    name: service.title,
    description: service.metaTags?.description || service.description,
    serviceType: service.title,
    url: service.metaTags?.url || getServiceHref(service),
    image: service.metaTags?.ogImage,
});

export const getBreadcrumbSeoItems = (
    items: Array<{ name: string; url?: string; item?: string }>,
): BreadcrumbItemInput[] =>
    items.map((item) => ({ name: item.name, url: item.url || item.item || "" }));
